import React from "react";
import "../App.css";
import hexagonText from "../images/hexagonText.png";
import hexagonGif from "../images/hexagon.gif";
import hexagonCourse from "../images/hexagonCourse.svg";
import hexagonHacker from "../images/hexagonHacker.svg";

import sp from "../images/S&P.png";

const ThirdScreen = () => {
    return (
        <div className="ts">
            <div className="ts-images">
                <div className="ts-1">
                    <a href="https://vva-informatisering.nl/landingpagina-cybersecurity/">
                        <img
                            src={hexagonText}
                            alt="hexagon met tekst"
                            className="hex-4"
                        />
                    </a>
                </div>
                <div className="ts-2">
                    <img
                        src={hexagonGif}
                        className="hex-5"
                        alt="Gif van Flipper"
                    />
                </div>
                <div className="ts-3">
                    <img
                        src={hexagonCourse}
                        alt="hexagon met afbeelding"
                        className="hex-6"
                    />
                </div>
                <div className="ts-4">
                    <img
                        src={hexagonHacker}
                        alt="hexagon met afbeelding"
                        className="hex-7"
                    />
                </div>
            </div>
            <div className="ts-5">
                <h4>
                    WindowsL.nl <br /> is een initiatief van
                </h4>
                <a href="https://vva-informatisering.nl/landingpagina-cybersecurity/">
                    <img
                        src={sp}
                        alt="security & privacy icon"
                        className="sp-icon"
                    />
                </a>
            </div>
        </div>
    );
};

export default ThirdScreen;
